import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useState } from "react";
import { genElDate, genElObject } from "../../../components/utils/EditorDialogElementGenerator";
import { useSelector } from "react-redux";
import WarehouseSelectorDialog from "../../../dialogs/selectors/WarehouseSelectorDialog";
import useIsMobile from "../../../hooks/useIsMobile";
import { Calendar } from "primereact/calendar";
import { format } from "date-fns";

const StockInFilter = (props) => {
  const {
    filterValue,
    setFilterValue,
    onClickRefresh,
    filterPendingValue,
    setFilterPendingValue,
  } = props;

  const employee = useSelector((state) => state.auth.employee);
  const [showWarehouseSelector, setShowWarehouseSelector] = useState(false);
  const isMobile = useIsMobile();

  const verificationOptions = [
    { label: "All Pending", value: "all" },
    { label: "Owner Verification", value: "owner" },
    { label: "Payment Verification", value: "payment" },
    { label: "Shipment Verification", value: "shipment" },
    { label: "Done Verification", value: "done" },
  ];

  const handleOnClickWarehouse = () => setShowWarehouseSelector(true);

  const handleOnConfirmWarehouse = (event, datas) => {
    event.preventDefault();
    if (datas && datas.length > 0) {
      const selected = datas[0];

      setFilterValue({
        ...filterValue,
        data_warehouse: selected,
        warehouse_id: selected.id,
      });

      setFilterPendingValue({
        ...filterPendingValue,
        data_warehouse: selected,
        warehouse_id: selected.id,
      });

      setShowWarehouseSelector(false);
      onClickRefresh?.();
    }
  };

  const handleVerificationChange = (e) => {
    setFilterPendingValue({
      ...filterPendingValue,
      verification_type: e.value ?? null,
    });
  };

  // Generated elements
  const elWarehouse = genElObject({
    field: "warehouse_id",
    name: "Warehouse",
    value: filterValue.data_warehouse ? filterValue.data_warehouse.name : "",
    onClick: handleOnClickWarehouse,
    onClear: () => {
      setFilterValue({ ...filterValue, data_warehouse: null, warehouse_id: null });
      setFilterPendingValue({
        ...filterPendingValue,
        data_warehouse: null,
        warehouse_id: null,
      });
      onClickRefresh?.();
    },
  });

  return (
    <div className="col-start-start w-full gap-4" style={{ display: "flex" }}>

      <WarehouseSelectorDialog
        title="Select Warehouse"
        visible={showWarehouseSelector}
        onHide={() => setShowWarehouseSelector(false)}
        onConfirm={handleOnConfirmWarehouse}
      />

      {/* ---------------------- ROW 1 (Top) ---------------------- */}
      <div
        className={
          isMobile
            ? "col-start-start w-full gap-4"
            : "row-start-end w-full gap-4"
        }
        style={{ display: "flex" }}
      >
        {/* Warehouse */}
        <div className="w-full grow-1">{elWarehouse}</div>

        {/* Number */}
        <div className="col-start-start w-full gap-1" style={{ display: "flex" }}>
          <label className="font-bold text-sm text-slate-500">Number</label>
          <InputText
            className="w-full"
            placeholder="Search Number"
            value={filterValue.number || ""}
            onChange={(e) =>
              setFilterValue({ ...filterValue, number: e.target.value })
            }
            onBlur={() => {
              setFilterPendingValue({
                ...filterPendingValue,
                number: filterValue.number,
              });
              onClickRefresh?.();
            }}
          />
        </div>

        {/* Verification */}
        <div className="col-start-start w-full gap-1" style={{ display: "flex" }}>
          <label className="font-bold text-sm text-slate-500">
            Pending Verification
          </label>
          <Dropdown
            className="w-full"
            value={filterPendingValue?.verification_type ?? null}
            options={verificationOptions}
            placeholder="Select Verification"
            onChange={handleVerificationChange}
          />
        </div>
      </div>

      {/* ---------------------- ROW 2 (Bottom) ---------------------- */}
      <div
        className={
          isMobile
            ? "col-start-start w-full gap-4"
            : "row-start-end w-full gap-4"
        }
        style={{ display: "flex" }}
      >

        <div className="w-full">
          <label className="font-bold text-sm text-slate-500">From</label>
          <Calendar
            value={filterValue.tanggal_from}
            onChange={(e) =>
              setFilterValue({ ...filterValue, tanggal_from: e.value })
            }
            showIcon
            dateFormat="dd MM yy"
            placeholder="Select From Date"
            className="w-full"
          />
        </div>

        <div className="w-full">
          <label className="font-bold text-sm text-slate-500">To</label>
          <Calendar
            value={filterValue.tanggal_to}
            onChange={(e) =>
              setFilterValue({ ...filterValue, tanggal_to: e.value })
            }
            showIcon
            dateFormat="dd MM yy"
            placeholder="Select To Date"
            className="w-full"
          />
        </div>

        {/* Refresh button always with date row */}
        <div className="row-end-center">
          <Button
            icon="pi pi-refresh"
            rounded
            outlined
            onClick={onClickRefresh}
          />
        </div>
      </div>

    </div>

  );
};

export default StockInFilter;
